import { render, staticRenderFns } from "./projectApply.vue?vue&type=template&id=23120096"
import script from "./projectApply.vue?vue&type=script&lang=js"
export * from "./projectApply.vue?vue&type=script&lang=js"
import style0 from "./projectApply.vue?vue&type=style&index=0&id=23120096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports